import React, { useState } from "react";
import { Box } from "@mui/material";
import Select, { TOption, TOptionType } from "../../../Components/Select";
import {
  getControlOptions,
  getCommandOptions,
  getCommandParameterOptions,
  findControl,
} from "../utils";
import { IControlCommandBase, IControl } from "../../controls/types";
import { TMqttAction } from "./types";
import { useTranslation } from "react-i18next";

interface IMqttActionFormProps {
  action: TMqttAction;
  controls: IControlCommandBase[];
  onChange: (mqttAction: TMqttAction) => void;
}

const MqttActionForm = (props: IMqttActionFormProps) => {
  const { action, controls, onChange } = props;
  const control_id = action.control_id || controls[0].id;
  const [controlId, setControlId] = useState<number>(control_id);
  const { t } = useTranslation();

  const [commandOptions, setCommandOptions] = useState<TOption<TOptionType>[]>(
    getCommandOptions(findControl(controls, controlId))
  );

  const initialCommand = action.command || (commandOptions[0].value as string);
  const [command, setCommand] = useState<string>(initialCommand);

  const [parameterOptions, setParameterOptions] = useState<
    TOption<TOptionType>[]
  >(
    getCommandParameterOptions(
      findControl(controls, controlId),
      command as string
    )
  );
  const initialParameter =
    action.parameter || (parameterOptions[0].value as string);
  const [parameter, setParameter] = useState<string>(initialParameter);

  const [mqttAction, setMqttAction] = useState<TMqttAction>({
    ...action,
    control_id: control_id,
    command: commandOptions[0].value as string,
  });

  const updateMqttAction = (newMqttAction: TMqttAction) => {
    setMqttAction(newMqttAction);
    onChange(newMqttAction);
  };

  return (
    <>
      <Select
        fullWidth
        label={t("Control")}
        options={getControlOptions(controls as IControl[])}
        value={controlId}
        onChange={(event) => {
          const newControlId = parseInt(event.target.value);
          const newCommandOptions = getCommandOptions(
            findControl(controls, newControlId)
          );
          setControlId(newControlId);
          setCommandOptions(newCommandOptions);
          setCommand(newCommandOptions[0].value as string);

          const newCommandParameterOptions = getCommandParameterOptions(
            findControl(controls, newControlId),
            newCommandOptions[0].value as string
          );
          setParameterOptions(newCommandParameterOptions);
          setParameter(newCommandParameterOptions[0].value as string);

          updateMqttAction({
            ...mqttAction,
            control_id: newControlId,
            command: newCommandOptions[0].value as string,
            parameter: newCommandParameterOptions[0].value as string,
          });
        }}
        margin="none"
        data-cy="mqtt-action-select-control"
      />
      <Box gap={1} display="flex" flexDirection="row" style={{ width: "100%" }}>
        <Select
          fullWidth
          label={t("Command")}
          value={command}
          options={commandOptions}
          onChange={(event) => {
            const newCommand = event.target.value;
            setCommand(newCommand);
            updateMqttAction({ ...mqttAction, command: newCommand });
          }}
          margin="none"
          style={{ width: "50%" }}
          data-cy="mqtt-action-select-command"
        />
        <Select
          label={t("Parameter")}
          options={parameterOptions}
          value={parameter}
          onChange={(event) => {
            const newParameter = event.target.value;
            setParameter(newParameter);
            updateMqttAction({ ...mqttAction, parameter: newParameter });
          }}
          margin="none"
          style={{ width: "50%" }}
          data-cy="mqtt-action-select-parameter"
        />
      </Box>
    </>
  );
};

export default MqttActionForm;
